import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ReactNode } from 'react';
import { Button } from '~/components/ui/button';

/**
 * One shape for every composer on either surface: what it is on the left, what
 * else it offers on the right, and the close on the far edge — beside the title
 * it reads as part of it.
 */
export function ComposerHeader({
  actions,
  children,
  context,
  onClose,
}: {
  actions?: ReactNode;
  children: ReactNode;
  /** A line under the header for what the message is answering. */
  context?: ReactNode;
  onClose?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between gap-2">
        <div className="flex min-w-0 items-center gap-1">{children}</div>
        <div className="flex shrink-0 items-center gap-2">
          {actions}
          {onClose && (
            <Button
              type="button"
              variant="muted"
              size="icon-xs"
              shape="pill"
              onClick={onClose}
              aria-label={t('Close composer')}
            >
              <X className="size-4" strokeWidth={2.5} />
            </Button>
          )}
        </div>
      </div>
      {context}
    </div>
  );
}
